import { useEffect, useRef, useState, type ReactNode, type ElementType } from "react";

interface RevealProps {
  children: ReactNode;
  delay?: 0 | 1 | 2 | 3 | 4;
  as?: ElementType;
  className?: string;
  style?: React.CSSProperties;
}

/** Envuelve contenido y lo anima al entrar en viewport (scroll reveal) */
export function Reveal({ children, delay = 0, as: Tag = "div", className = "", style }: RevealProps) {
  const ref = useRef<HTMLElement | null>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15, rootMargin: "0px 0px -40px 0px" }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const delayClass = delay ? ` reveal--delay-${delay}` : "";

  return (
    <Tag ref={ref} className={`reveal${visible ? " reveal--visible" : ""}${delayClass} ${className}`} style={style}>
      {children}
    </Tag>
  );
}
